export const Copyright = '© 2023 MIXIE DIGITAL SL.';
